export default "__VITE_ASSET__82ea1346__"